import { AnalyticsDataTable, ApiPagination } from "@/components";
import { useEffect, useState } from "react";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchCustomPaginatedOrdersQueryOptions } from "@/queryOptions/orders/fetchCustomPaginatedOrders";

const AnalyticsDataTableWrapper = () => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [date,setDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30)).toISOString()
  );

  const {
    data: queryResult,
    isLoading: productsLoading,
    fetchNextPage,
    hasNextPage,
    isSuccess,
    isFetchingNextPage,
  } = useInfiniteQuery(
    fetchCustomPaginatedOrdersQueryOptions({ created_at: { gt: date } }, 10, {
      staleTime: 1000 * 60 * 5,
      enabled: !isSearchActive,
    })
  );
  const currentPage = queryResult?.pages?.[currentPageIndex];

  useEffect(() => {
    if (isSuccess && queryResult?.pages?.length === 1 && hasNextPage) {
      fetchNextPage();
    }
  }, [isSuccess, queryResult?.pages?.length, hasNextPage, fetchNextPage]);

  const totalPages = queryResult?.pages?.length || 0;
  const handlePrevious = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const handleNext = async () => {
    const nextPageIndex = currentPageIndex + 1;

    if (queryResult?.pages?.[nextPageIndex]) {
      setCurrentPageIndex(nextPageIndex);

      if (!queryResult.pages[nextPageIndex + 1] && hasNextPage) {
        fetchNextPage();
      }
    } else if (hasNextPage) {
      // If next page doesn't exist but more data is available, fetch it
      await fetchNextPage();
      setCurrentPageIndex(nextPageIndex);
    }
  };
  return (
    <AnalyticsDataTable
      data={currentPage?.items ?? []}
      children={
        <ApiPagination
          currentPageIndex={currentPageIndex}
          totalPages={totalPages}
          hasNextPage={currentPageIndex < (queryResult?.pages?.length || 0) - 1 || hasNextPage}
          isFetching={isFetchingNextPage}
          onPrevious={handlePrevious}
          onNext={handleNext}
          variant="minimal"
        />
      }
    />
  );
};

export default AnalyticsDataTableWrapper;
